import React from 'react';
import { Divider, Form, Checkbox, Label } from 'semantic-ui-react';
import MenuUtil from '../utils/menu';

const ModifierSetSelection = ({
  _id,
  name,
  allModifiers,
  modifierSets,
  onSelectModifier,
  isModifierSelected,
  isModifierDisabled,
  checkoutDisabled,
  showDivider = true,
}) => {
  const modifierSet = MenuUtil.getModifierSetById(modifierSets, _id);
  const { modifiers: modifierSetModifierIds } = modifierSet;
  const modifierSetModifiers = MenuUtil.getModifierSetModifiers(
    modifierSetModifierIds,
    allModifiers,
  );
  const { minAllowed, maxAllowed } = modifierSet;
  const modifierSelectionDescription = getModifierSelectionText(minAllowed, maxAllowed);

  return (
    modifierSetModifiers.length > 0 && (
      <div className="item-cart-modifier-set-selection">
        {showDivider && <Divider />}
        <div className="modifier-set-selection-header">
          <h5>{name.toUpperCase()}</h5>
          {minAllowed > 0 ? (
            <Label color="blue">REQUIRED</Label>
          ) : (
            <Label color="blue">OPTIONAL</Label>
          )}
        </div>
        {modifierSelectionDescription && (
          <div className="modifier-set-selection-description">
            {modifierSelectionDescription}
          </div>
        )}
        <Form>
          {modifierSetModifiers.map((modifier, index) => {
            const { _id: modifierId, name, price } = modifier;

            return (
              <div className="modifier-set-selection-checkbox" key={name}>
                <Form.Field>
                  <Checkbox
                    label={name}
                    name="modifier"
                    checked={isModifierSelected(modifierId)}
                    onChange={() => onSelectModifier(modifier, modifierSet)}
                    disabled={checkoutDisabled || isModifierDisabled(modifierSet, modifierId)}
                  />
                </Form.Field>
                <div>{price && price !== 0 ? `$${price.toFixed(2)}` : '-'}</div>
              </div>
            );
          })}
        </Form>
      </div>
    )
  );
};

function getModifierSelectionText(min, max) {
  if (min === 0 && max === 0) return 'Select any';
  if (min > 0 && max === 0) return `Select a minimum of ${min}`;
  if (min > 0 && max > 0) {
    if (min === max) return `Select ${min}`;
    return `Select ${min} to ${max}`;
  }
  return '';
}

export default ModifierSetSelection;
